import {Header} from '@/components';

import WebhookSimulatorForm from './WebhookSimulatorForm';

export default function WebhookSimulatorScreen() {
  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <Header title="Webhook Simulator" />
      <p className="text-sm text-gray-700 dark:text-gray-200 mt-2">
        Only the processors listed below can be simulated. To test a deposit or
        payout through any other processor (GPay, Pawapay, …), run it on
        staging, where the sandbox emulator settles it through the real
        crediting path. See{' '}
        <a
          href="https://github.com/Afri-exchange/afriex-server/wiki/Sandbox-Simulators#24-what-the-sandbox-cannot-simulate"
          target="_blank"
          rel="noopener noreferrer"
          className="text-cyan-700 hover:underline"
        >
          Sandbox Simulators
        </a>
        .
      </p>
      <section className="pt-5 md:pt-5">
        <WebhookSimulatorForm />
      </section>
    </main>
  );
}
